import { useEffect, useState } from "react";
import { tickerNews } from "@/mocks/news";

const navItems = [
  { href: "#live", label: "现场直击" },
  { href: "#hot", label: "今日热榜" },
  { href: "#columns", label: "主题分类" },
  { href: "#digest", label: "热点速报" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 shadow-none border-b border-background-200"
          : "bg-background-50"
      }`}
    >
      {/* top ticker bar */}
      <div className="border-b border-background-200 bg-foreground-950 text-background-50">
        <div className="mx-auto flex w-full max-w-7xl items-center gap-3 px-4 md:px-6 py-2 overflow-hidden">
          <span className="font-label shrink-0 whitespace-nowrap text-xs text-accent-400 flex items-center gap-1.5">
            <i className="ri-flashlight-fill text-sm" aria-hidden="true"></i>
            速递
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex min-w-max animate-marquee gap-10">
              {[...tickerNews, ...tickerNews].map((n, i) => (
                <span key={i} className="whitespace-nowrap text-xs text-foreground-200">
                  <em className="not-italic mr-1.5 text-accent-300/70">{n.time}</em>
                  {n.text}
                </span>
              ))}
            </div>
          </div>
          <span className="font-label hidden md:inline whitespace-nowrap text-xs text-foreground-300">
            正在直播围观
          </span>
        </div>
      </div>

      {/* main nav */}
      <div className="mx-auto flex w-full max-w-7xl items-center justify-between gap-6 px-4 md:px-6 py-3.5">
        <a href="#top" className="flex items-center gap-2.5 shrink-0" aria-label="17吃瓜首页">
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-none">
            <i className="ri-water-flash-line text-xl" aria-hidden="true"></i>
          </span>
          <span className="leading-none">
            <span className="font-heading block text-xl font-bold tracking-tight text-foreground-950">
              17吃瓜
            </span>
            <span className="block text-[10px] text-foreground-500 mt-1 whitespace-nowrap">
              CHIGUA · 围观不迷路
            </span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-primary-100 hover:text-primary-700"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden sm:inline-flex whitespace-nowrap items-center gap-1.5 rounded-md bg-foreground-950 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
          >
            <i className="ri-notification-3-line" aria-hidden="true"></i>
            订阅速报
          </a>
          <button
            type="button"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label={mobileOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={mobileOpen}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-900 lg:hidden"
          >
            <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
          </button>
        </div>
      </div>

      {/* mobile menu */}
      {mobileOpen && (
        <nav
          className="lg:hidden border-t border-background-200 bg-background-50 px-4 pb-4 pt-2"
          aria-label="移动端导航"
        >
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={() => setMobileOpen(false)}
              className="block rounded-md px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100"
            >
              {item.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}